import type { ServerToClientEvent } from '@atlassian/jira-s2c-event/src/index.tsx';

const events: ServerToClientEvent[] = [];

const registerEvent = (event: ServerToClientEvent) => {
	events.push(event);
};

/**
 * Take all events registered so far, return them, and clear the list.
 */
const drainEvents = (): ServerToClientEvent[] => {
	return events.splice(0, events.length);
};

export { registerEvent, drainEvents };
